module.exports = __webpack_public_path__ + "assets/img/33_1574_big.be564308.jpg";